import { isKeySpace } from './is-key-space.js';
import { isKeyEnter } from './is-key-enter.js';

export function isKeyEnterOrKeySpace(ev) {
  return isKeySpace(ev) || isKeyEnter(ev);
}
